import { SignedIn, SignedOut } from "components/clerk";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Seo from "components/general/Seo";
import { PageRender } from "components/page/PageRender";
import { Box, Text } from "components/ui";
import React from "react";
import { ActivityIndicator } from "react-native";
import Dashboard from "screens/Dashboard";
import { useGetPageQuery } from "store/abcoApi";
// import {LineChart} from "react-gifted-charts";

export default function HomePage() {
	// const lineData = [
	// 	{value: -10, label:'aaa'},
	// 	{value: -10, label:'20'},
	// 	{value: 20, label:'-18'},
	// 	{value: 30, label:'40'},
	// 	{value: -10, label:'36'},
	// 	{value: 50, label:'-60'},
	// 	{value: 60, label:'54'},
	// 	{value: 70, label:'85'},
	//   ];

	const { data: publicPage, isLoading: pageIsLoading, isFetching: pageIsFetching } = useGetPageQuery({ path: String("/public-homepage") });
	return (
		<ScrollContainer>
			<Seo title={publicPage?.metaTitle} description={publicPage?.metaDescription} />

			<SignedIn>
				<Dashboard />
			</SignedIn>

			<SignedOut>
				{pageIsLoading && (
					<Box minHeight={600} marginTop={50}>
						<ActivityIndicator size={"large"} color={"#1A428A"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} />
					</Box>
				)}
				{publicPage && <PageRender content={publicPage.content} />}

				{/* <CategoryCardTabList /> */}
			</SignedOut>
		</ScrollContainer>
	);
}
